import React from "react";
import styled from "styled-components";
// import { Link } from "react-router-dom";

// Components
import Card from "./Card";
import Quote1 from "../components/Quote1";
import Quote2 from "../components/Quote2";

const Portfolio = () => {
  return (
    <Container>
      <h1>
        <div className="title">Portfolio</div>
      </h1>
      <Grid>
        <Card
          // img={require("")}
          title="Graphic Design"
          description="Find all graphic related design work here..."
          technologies=""
          link_one="/portfolio/graphic_design"
          link_one_text="Graphic"
        />
        <Card
          // img={require("")}
          title="Brand Design"
          description="Find all branding related design work here..."
          technologies=""
          link_one="/portfolio/brand_design"
          link_one_text="Branding"
        />
        <Card
          // img={require("")}
          title="Packaging Design"
          description="Find all Packaging related design work here..."
          technologies=""
          link_one="/portfolio/packaging_design"
          link_one_text="Packaging"
        />
        <Quote1 />
        <Card
          // img={require("")}
          title="Social Media"
          description="Find all social media related design work here..."
          technologies=""
          link_one="/portfolio/social_media"
          link_one_text="Social"
        />
        <Card
          // img={require("")}
          title="App Development"
          description="Find all app related design & development work here..."
          technologies=""
          link_one="/portfolio/app_development"
          // link_two="https://"
          // link_three="https://"
          link_one_text="App Dev"
          // link_two_text=""
          // link_three_text=""
        />
        <Card
          // img={require("")}
          title="Web Development"
          description="Find all web related design & development work here..."
          technologies=""
          link_one="/portfolio/web_development"
          link_one_text="Web Dev"
        />
        <Card
          // img={require("")}
          title="Furniture Design"
          description="Find all furniture related design work here..."
          technologies=""
          link_one="/portfolio/furniture_design"
          link_one_text="Furniture"
        />
        <Quote2 />
        <Card
          // img={require("")}
          title="Interior Design"
          description="Find all Interior Architecture related design work here..."
          technologies=""
          link_one="/portfolio/interior_architecture"
          link_one_text="Interior"
        />
        <Card
          // img={require("")}
          title="Architectural Design"
          description="Find all Architecture related design work here..."
          technologies=""
          link_one="/portfolio/architecture"
          link_one_text="Architectural"
        />
        <Card
          // img={require("")}
          title="Paintings"
          description="Find all Painted related work here..."
          technologies=""
          link_one="/portfolio/paintings"
          link_one_text="Paintings"
        />
      </Grid>
    </Container>
  );
};

const Container = styled.div`
  flex: 1;
  height: 20vh;
  margin-left: 15%;
  margin-right: 15%;
  align-items: center;
  justify-content: center;
  @media (max-width: 40rem) {
    margin-top: 5rem;
  }
  .title {
    color: #fff;
    text-align: center;
  }

  h1 {
    font-size: 3rem;
    padding-top: 6rem;
    padding-bottom: 2rem;

    @media (max-width: 40rem) {
      font-size: 2.5rem;
      padding: 1.5rem;
      padding-top: 3rem;
    }
  }
`;

const Grid = styled.div`
  color: #fff;
  box-sizing: border-box;
  padding: 1rem;

  @media (max-width: 40rem) {
    padding: 1.5rem;
  }

  display: grid;
  grid-template-columns: repeat(auto-fill, 18rem);
  grid-auto-rows: 18rem;
  grid-gap: 2.5rem;
  justify-content: center;
  margin-bottom: 10rem;
`;

export default Portfolio;
